import React from "react";
import { errorLogProvider } from "./players/errorBoundaryFunctions";

class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null, errorInfo: null };

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        this.setState({ error: error, errorInfo: errorInfo });
        errorLogProvider({ type: "OTHER_ERROR", message: error.message });
    }

    render() {
        if (this.state.hasError) {
            return <></>;
        }

        return (this.props as any).children;
    }
}

export default ErrorBoundary;
